import { CustomerInterface } from '../../models/customer.interface';

export interface CustomerInterfaceState {
  customer: CustomerInterface;
}

export const initialCustomerState: CustomerInterfaceState = {
  customer: null
};
